module.exports = __webpack_public_path__ + "img/yjkong@2x.a086b17c.png";